module.exports = __webpack_public_path__ + "img/13_19.575606f1.png";